import {WinPresentationController} from "../WinPresentationController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {gsap, TimelineLite} from "gsap";


export class BrokeTheBankController extends WinPresentationController {

    constructor() {
        super("BreakBankController", false);
        //this is for wincap in base game , using different signatures than simplepresentation
    }

    protected hasWin(): boolean {
        return DevilsCrossRoad.model.gameData.brokeTheBank;
    }

    protected async createWinAnimation(): Promise<any> {

        const tl = gsap.timeline();

        await Promise.resolve(tl);

        await new Promise<void>(resolve => {
            DevilsCrossRoad.wincapScreen.show(() => {
                DevilsCrossRoad.keypadPlugin.setZeroBetSpinCounter(-1);
                resolve();
            });
        });
    }
}